/*
 * @Author: 张玉婷
 * @Date: 2022-02-15 15:42:04
 * @LastEditTime: 2022-05-19 12:09:25
 * @LastEditors: PanYunhong
 * @Description:
 * @FilePath: \air_version_2\src\utils\AMap\marker\index.ts
 */

import { getselecdedAqiImg, fontColorRender, } from '@/utils/index';

export default class Marker extends AMap.Text<any> {
  map: any;

  data: any;

  constructor (map: any, data: any) {
    super({
      map,
      position: [parseFloat(data.lon),parseFloat(data.lat),],
      text: `${data.aqi !== '-9999' && data.aqi !== null ?
        Number(data.aqi).toFixed(0) :
        '-'
      }`,
      clickable: true,
      anchor: 'center-center',
      style: {
        // 0.46 * 1.2
        width: '0.36rem',
        height: '0.36rem',
        'line-height': '0.33rem',
        border: 'none',
        background: `url(${getselecdedAqiImg(data.aqi === null ?
          -9999 :
          Number(data.aqi)).replace(/_selected/g, '')}) no-repeat`,
        'background-size': '100% 100%',
        color: `${fontColorRender(Number(data.aqi), 'aqi')}`,
        'font-size': '0.14rem',
        'font-family': 'SourceHanSansCN-Normal',
        'font-weight': '400',
        overflow: 'visible',
        // '-webkit-text-stroke': '0.5px #000',
      },
      topWhenClick: true,
      zIndex: 12,
    });
    this.data = data;
  }
}
